import React, { useState, useEffect, useRef } from 'react';
import './Skills.css';

const Skills = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const skillsData = {
    domains: [
      'Autonomous Vehicles', 'Computer Vision', 'Signal Processing',
      'Wireless',
    ],
    technical: [
      'Deep Learning', 'Neural Networks', 'FPGA/Verilog', 'Real-time Systems', 'Reinforcement Learning'
    ],
    stack: [
      'Python', 'PyTorch', 'React', 'Node.js', 
    ]
  };

  return (
    <section id="skills" className="skills" ref={sectionRef}>
      <div className="container">
        <div className={`skills-header ${isVisible ? 'visible' : ''}`}>
          <h2 className="section-title">Skills & Expertise</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">Core competencies in AI, signal processing, and autonomous systems</p>
        </div>

        <div className={`skills-content ${isVisible ? 'visible' : ''}`}>
          <div className="skills-section">
            <h3 className="section-label">Domain Expertise</h3>
            <div className="skills-group domain-skills">
              {skillsData.domains.map((skill, i) => (
                <span key={i} className="skill-tag domain">{skill}</span>
              ))}
            </div>
          </div>

          <div className="skills-section">
            <h3 className="section-label">Technical Foundations</h3>
            <div className="skills-group technical-skills">
              {skillsData.technical.map((skill, i) => (
                <span key={i} className="skill-tag technical">{skill}</span>
              ))}
            </div>
          </div>

          <div className="skills-section">
            <h3 className="section-label">Technology Stack</h3>
            <div className="skills-group stack-skills">
              {skillsData.stack.map((skill, i) => (
                <span key={i} className="skill-tag stack">{skill}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
